<!-- <div #holder class="background" class="fit" style="overflow: hidden; position: absolute;"> -->
<div class="background">
    <router-outlet></router-outlet>
    <!-- used by Alert.ts -->
    <alert #alert></alert>

    <!-- allows login via LoginComponent.show -->
    <login></login>
</div>